import angular from 'angular';
import * as call from '../../../modules/call';
import mini from './self-screen-frame-mini/self-screen-frame-mini';
import template from './self-screen-frame.html';
class SelfScreenFrameController {
    constructor($element, VideoProviderFactory, $ngRedux) {
        this.$element = $element;
        this.$ngRedux = $ngRedux;
        this.isSelfScreenLoading = true;
        VideoProviderFactory.decorateScope(this);
        this.screenPublisherId =
            VideoProviderFactory.activeProvider.localScreenPublisherId;
        this.unsubscribeFromStore = this.$ngRedux.connect((state) => ({
            isPreviewsListVisible: call.selectors.selectPreviewsListVisibility(state),
        }))(this);
    }
    $onInit() {
        const observer = new MutationObserver((mutations) => {
            for (const mutation of mutations) {
                if (mutation.addedNodes.length > 0) {
                    this.$element[0].querySelector('video')?.addEventListener('loadeddata', () => {
                        this.isSelfScreenLoading = false;
                        observer.disconnect();
                    }, { once: true });
                }
            }
        });
        observer.observe(this.$element[0], { childList: true, subtree: true });
    }
    get isMiniFrameVisible() {
        return this.isPreviewsListVisible && (!this.isFull || this.isInGroupCall);
    }
    $onDestroy() {
        this.unsubscribeFromStore();
    }
}
const component = {
    template,
    bindings: {
        onSelect: '&',
        isInGroupCall: '<',
        isFull: '<',
        isGalleryView: '<',
        isPinned: '<',
        avatarPicture: '<',
    },
    controller: SelfScreenFrameController,
};
export default angular
    .module('doxy.videoChat.callFrames.selfScreenFrameComponent', [mini])
    .component('selfScreenFrame', component).name;
